/**
 * ExportacoesPage (M9, RF-M9-006) — tela "Exportações": formulário de nova
 * exportação + tabela "Minhas exportações" com polling.
 *
 * Acesso universal de leitura (RN-M7-001): qualquer perfil autenticado exporta.
 * Recebe escopo/filtro pré-selecionados via `location.state` dos atalhos de
 * outras telas ("Exportar visitas desta escola" → escola; "Exportar este
 * resultado" → filtro). Nenhum dado pessoal em console/analytics (RN-M11-001).
 */

import { useLocation } from 'react-router-dom';
import { NovaExportacaoForm } from '../components/NovaExportacaoForm';
import { MinhasExportacoesTable } from '../components/MinhasExportacoesTable';
import { useListaExportacoes } from '../hooks/useExportacoes';
import { ExportacaoEscopo, ExportacaoFiltro } from '../services/exportacoes-types';

/** Estado de navegação aceito dos atalhos de outras telas. */
interface ExportacaoNavState {
  readonly escopo?: ExportacaoEscopo;
  readonly filtro?: ExportacaoFiltro;
}

export function ExportacoesPage(): JSX.Element {
  const location = useLocation();
  const nav = (location.state ?? {}) as ExportacaoNavState;
  const { itens, carregando, erro, recarregar } = useListaExportacoes();

  return (
    <div>
      <h1 className="page-title">Exportações</h1>
      <p className="page-subtitle">
        Gere a base de visitas — inteira ou filtrada — em CSV ou JSON Lines. A geração roda em
        segundo plano; você é avisado na tela e por e-mail quando o arquivo fica pronto.
      </p>

      <NovaExportacaoForm
        escopoInicial={nav.escopo}
        filtroInicial={nav.filtro}
        onCriada={recarregar}
      />

      <section className="card">
        <h2>Minhas exportações</h2>
        {carregando && <p className="muted">Carregando…</p>}
        {erro && <p className="notice">Não foi possível carregar as exportações.</p>}
        {!carregando && !erro && <MinhasExportacoesTable itens={itens} />}
      </section>
    </div>
  );
}
